import { EnumSiNoTodos, FilterSearchingBaseViewModel, PagingResultsViewModel } from 'src/app/components/core/_infrastructure/types/common';
import { CultivoViewModel } from '../cultivos/cultivo.types';

export class RecintoItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: RecintoItemViewModel[];
}
export class RecintoItemViewModel {
    // public IdCultivo: number;
    public Id: number; // Será el id del Recinto
    public Titular: string;
    public Nif: string;
    public TipoRecinto: string;
    public IdProvincia: number;
    public Provincia: string;
    public IdMunicipio: number;
    public IdMunicipioSigPac: number;
    public Municipio: string;
    public Agregado: number;
    public Zona: number;
    public Poligono: number;
    public Parcela: number;
    public Recinto: number;
    public SuperficieTotal: number;
    // Campo usado en la funcionalidad de gestión de cultivos de la solicitud de campaña.
    // NO viajan al core
    public IdUsuario?: number;
    public DadoDeBaja?: number; // Se refiere al cultivo
    public TwCultivoCollection?: CultivoViewModel[];
}

export class FilterSearchingTWRecintoViewModel extends FilterSearchingBaseViewModel {
    public Titular: string;
    public Nif: string;
    public IdTipoRecinto: number;
    public IdProvincia: number;
    public IdMunicipio: number;
    public Agregado: number;
    public Zona: number;
    public Poligono: number;
    public Parcela: number;
    public Recinto: number;
    public EsCompleta: number;
    public Autorizado: number = EnumSiNoTodos.TODOS;
    // Campos utilizados en el modo de búsqueda Embedded.
    // Este modo se utiliza cuando el buscador de cultivos, está embebido en la pantalla de solicitudes de campaña.
    // En éste caso, se filtra también por Periodo. Si no se indica provincia, se filtrará por la CA del periodo.
    public IdPeriodoCam?: number;
    public IdCa?: number;
    public IdSolicitudCam?: number;
    public IdCampania: number;
}

export class TwRecintoViewModel {
    public Id: number | null;
    public Titular: string;
    public Nif: string;
    public IdTipoRecinto: number;
    public SuperficieTotal: number;
    public UsoSigPac: string;
    public IdProvincia: number;
    public IdMunicipio: number;
    public IdMunicipioSigPac: number;
    public Agregado: number;
    public Zona: number;
    public Poligono: number;
    public Parcela: number;
    public Recinto: number;
    public EsCompleta = 0;
    public FechaCreacion?: Date;
    public IdUsuario: number;
}

export class RecintoPIAEdListViewModel {
    public Ids: number[];
}
